import { get } from '../../utils/http';

// Keyset-paginated, but unlike fetchAuditLogs giovanni rejects token 0 here: page 1 sends no token
export const fetchOpeningAuditLog = ({ accountId, openingId, token, pageSize }) =>
  get(`/accounts/${accountId}/ats/openings/${openingId}/recent-actions`, { ...(token ? { token } : {}), pageSize });
